/**
 * Mobile Media Centre Page
 * 
 * Uses the existing MediaCentreComponent since it's already responsive
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobileLayout from './MobileLayout';
import MediaCentreComponent from '../../components/Common/MediaCentre';

function MobileMediaCentre() {
    const navigate = useNavigate();
    
    return (
        <MobileLayout 
            title="Media Centre" 
            showBackButton={true} 
            onBackClick={() => navigate('/mobile')}
            backButtonIcon="home"
        >
            <div id='mediaCentrePage'>
                <MediaCentreComponent />
            </div>
        </MobileLayout>
    );
}

export default MobileMediaCentre; 